module.exports = __webpack_public_path__ + "img/dcg2.1257fef9.jpg";